module.exports = __webpack_public_path__ + "img/pt-br.fe118400.png";